module.exports = __webpack_public_path__ + "static/media/siddharth-tv.4a2975f0.jpg";